module.exports = __webpack_public_path__ + "static/img/041志愿者.fcb70d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/041志愿者.jpg
// module id = IMGG
// module chunks = 0